import getMe from 'api/me/getMe'

interface InitializeScormProps {
  API_1484_11: {
    SetValue: (key: string, value: string) => void
    cmi: {
      learner_id: string
      learner_name: string
    }
  }
  API: {
    LMSSetValue: (key: string, value: string) => void
    cmi: {
      core: {
        student_id: string
        student_name: string
      }
    }
  }
}

export async function initializeScorm({
  API_1484_11,
  API,
}: InitializeScormProps) {
  const user = await getMe()
  if (user) {
    const identifier = user.identifier
    const fullName = user.fullName

    // Set SCORM 2004 values
    API_1484_11.cmi.learner_id = identifier
    API_1484_11.cmi.learner_name = fullName

    // Set SCORM 1.2 values
    API.cmi.core.student_id = identifier
    API.cmi.core.student_name = fullName
  }
}
